import {Component, Output, EventEmitter, Input, inject, OnInit} from '@angular/core';
import {CoreService} from '@services/core.service';
import {MatDialog} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {RouterModule} from '@angular/router';
import {TablerIconsModule} from 'angular-tabler-icons';
import {MaterialModule} from '@app/material.module';
import {BrandingComponent} from '@layout/full-layout/branding/branding.component';
import {AppSettings} from '@app/config';
import {FormsModule} from '@angular/forms';
import {navItemsSuperadmin} from '@core/data/sidebar/sidebar-superadmin-data';

interface notifications {
  id: number;
  icon: string;
  color: string;
  title: string;
  time: string;
  subtitle: string;
}

interface profiledd {
  id: number;
  title: string;
  link: string;
  new?: boolean;
}

interface apps {
  id: number;
  icon: string;
  color: string;
  title: string;
  subtitle: string;
  link: string;
}

@Component({
  selector: 'app-horizontal-header',
  imports: [RouterModule, TablerIconsModule, MaterialModule, BrandingComponent],
  templateUrl: './header.component.html',
  standalone: true
})
export class AppHorizontalHeaderComponent implements OnInit {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  showFiller = false;

  private settings: CoreService = inject(CoreService);
  private vsidenav: CoreService = inject(CoreService);
  public dialog: MatDialog = inject(MatDialog);
  private translate: TranslateService = inject(TranslateService);

  @Output() optionsChange = new EventEmitter<AppSettings>();

  public selectedLanguage: any = {
    language: 'English',
    code: 'en',
    type: 'US',
    icon: '/assets/images/flag/icon-flag-en.svg',
  };

  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: '/assets/images/flag/icon-flag-en.svg',
    },
    {
      language: 'Español',
      code: 'es',
      icon: '/assets/images/flag/icon-flag-es.svg',
    },
    {
      language: 'Français',
      code: 'fr',
      icon: '/assets/images/flag/icon-flag-fr.svg',
    },
    {
      language: 'Deutsch',
      code: 'de',
      icon: '/assets/images/flag/icon-flag-de.svg',
    },
  ];

  private readonly LANG_KEY = 'app_language';

  constructor() {
    this.translate.setDefaultLang('en');
  }

  ngOnInit(): void {
    const savedCode = localStorage.getItem(this.LANG_KEY);
    if (savedCode) {
      const lang = this.languages.find((l: any) => l.code === savedCode);
      if (lang) {
        this.selectedLanguage = lang;
        this.translate.use(lang.code);
        this.settings.setLanguage(lang.code);
      }
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(AppHorizontalSearchDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  changeLanguage(lang: any): void {
    this.translate.use(lang.code);
    this.selectedLanguage = lang;
    this.settings.setLanguage(lang.code);
    localStorage.setItem(this.LANG_KEY, lang.code);
  }

  options = this.settings.getOptions();

  private emitOptions() {
    this.optionsChange.emit(this.options);
  }

  setlightDark(theme: string) {
    this.options.theme = theme;
    this.emitOptions();
  }

  notifications: notifications[] = [
    {
      id: 1,
      icon: 'a-b-2',
      color: 'primary',
      time: '8:30 AM',
      title: 'Launch Admin',
      subtitle: 'Just see the my new admin!',
    }
  ];

  profiledd: profiledd[] = [
    {
      id: 1,
      title: 'My Profile',
      link: '/',
    },
    {
      id: 2,
      title: 'My Subscription',
      link: '/',
    },
    {
      id: 3,
      title: 'My Invoice',
      new: true,
      link: '/',
    },
    {
      id: 4,
      title: ' Account Settings',
      link: '/',
    },
    {
      id: 5,
      title: 'Sign Out',
      link: '/authentication/login',
    },
  ];

  apps: apps[] = [
    {
      id: 1,
      icon: 'solar:chat-line-line-duotone',
      color: 'primary',
      title: 'Chat Application',
      subtitle: 'Messages & Emails',
      link: '/',
    }
  ];
}

@Component({
  selector: 'app-search-dialog',
  imports: [RouterModule, MaterialModule, TablerIconsModule, FormsModule],
  standalone: true,
  templateUrl: 'search-dialog.component.html',
})
export class AppHorizontalSearchDialogComponent {
  searchText: string = '';
  navItems = navItemsSuperadmin;

  navItemsData = this.navItems.filter((navitem) => navitem.displayName);

  // filtered = this.navItemsData.find((obj) => {
  //   return obj.displayName == this.searchinput;
  // });
}
